import React from 'react';

export const SurveyIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1416 9.42114H4.06982V7.42114H18.1416V9.42114Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.16162 5H17.05C17.6023 5 18.05 5.44772 18.05 6V11.1906C18.2982 11.5408 18.4441 11.9686 18.4441 12.4305V13.3557C18.7851 12.8156 19.3735 12.4473 20.05 12.4099V6C20.05 4.34315 18.7069 3 17.05 3H5.16162C3.50477 3 2.16162 4.34315 2.16162 6V17.9514C2.16162 19.6083 3.50477 20.9514 5.16162 20.9514H10.0904C10.0873 20.9042 10.0856 20.8567 10.0856 20.8088V18.9514H5.16162C4.60934 18.9514 4.16162 18.5037 4.16162 17.9514V6C4.16162 5.44772 4.60934 5 5.16162 5Z"
      fill="#27B0E0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3208 11.2849C17.1492 11.2849 17.8208 11.9565 17.8208 12.7849L17.8208 20.7454C17.8208 21.5739 17.1492 22.2455 16.3208 22.2455C15.4924 22.2455 14.8208 21.5739 14.8208 20.7454L14.8208 12.7849C14.8208 11.9565 15.4924 11.2849 16.3208 11.2849ZM20.3419 13.1556C21.1704 13.1575 21.8404 13.8307 21.8384 14.6591L21.8243 20.7488C21.8224 21.5772 21.1492 22.2472 20.3208 22.2453C19.4924 22.2434 18.8224 21.5702 18.8243 20.7418L18.8384 14.6521C18.8404 13.8237 19.5135 13.1537 20.3419 13.1556ZM13.8208 16.7652C13.8208 15.9367 13.1492 15.2652 12.3208 15.2652C11.4924 15.2652 10.8208 15.9367 10.8208 16.7652V20.7454C10.8208 21.5739 11.4924 22.2455 12.3208 22.2455C13.1492 22.2455 13.8208 21.5739 13.8208 20.7454L13.8208 16.7652Z"
      fill="#27B0E0"
    />
  </svg>
);
